<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hestadisticas">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>ESTADÍSTICAS</h1>
                    <p>
                        Fundación BEST en números. Se están otorgando <span style="font-weight: 700;">{{this.cifra | number}}</span> consultas al mes, en los consultorios que tenemos en todo el país ya que nuestro lema es <span style="font-weight: 700;">“Unidos Para Ayudar”</span>.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

<div class="contenedorIntSub">
    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dDiez dmOnce FcttAzul flx">
                <div class="dSeis dmSeis FcfrBllt">
                <a>
                    <img src="./assets/images/icon-consultorios.svg" alt="Consultas y consultorios">
                    <p class="FcifrasDatos">
                        CONSULTAS Y<br/>CONSULTORIOS
                    </p>
                </a>
                </div>
                <div class="dSeis dmSeis FcfrBllt">
                <a (click)="go()">
                    <img src="./assets/images/icon-consultasEstado.svg" alt="Consultas por estado">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>POR ESTADO
                    </p>
                </a>
                </div>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>

    <div class="Fgrafica dDoce dmOnce">
        <div class="Fgrafica dDiez dtOnce dmDoce">
            <h2>
                ESTADÍSTICA CONSULTAS<br />
                <span>Crecimiento en número de consultas</span>
            </h2><br>
            <div class="fondografic">
                <div class="barTrHead ">
                    <div class="bar" id="b01"></div>
                    <p class="pGraphInt">30,000,000</p>
                    <div class="bar" id="b02"></div>
                    <p class="pGraphInt">60,000,000</p>
                    <div class="bar" id="b03"></div>
                    <p class="pGraphInt">90,000,000</p>
                    <div class="bar" id="b04"></div>
                    <p class="pGraphInt">120,000,000</p>
                    <div class="bar" id="b05"></div>
                    <p class="pGraphInt">150,000,000</p>
                    <div class="lineas-verticales">
                        <div class="linea-vertical" id="v1"></div>
                        <div class="linea-vertical" id="v2"></div>
                        <div class="linea-vertical" id="v3"></div>
                        <div class="linea-vertical" id="v4"></div>
                        <div class="linea-vertical" id="v5"></div>
                        <div class="linea-vertical" id="v6"></div>
                    </div>
                </div>
                <div class="barras-totales">
                    <div class="barTr " *ngFor="let consulta of consultas; let i = index">
                        <div class="bar" id="br{{+i}}" [ngStyle]="{ 'width': (consulta.percent / 1.35) + '%' }">
                            <span class="label">{{consulta.year}}</span>
                        </div>
                        <p class="pGraph">{{consulta.quantity | number }}</p>
                    </div>
                    
                </div>
            </div>

        <div class="Fgrafica  dtOnce dmDoce">
            <h2>
                ESTADÍSTICA CONSULTORIOS<br />
                <span>Crecimiento en número de consultorios</span>
            </h2><br>
            <div class="fondografic">
            <div class="barTrHead">
                <div class="bar" id="c01"></div>
                <p class="pGraphInt">2,000</p>
                <div class="bar" id="c02"></div>
                <p class="pGraphInt">4,000</p>
                <div class="bar" id="c03"></div>
                <p class="pGraphInt">6,000</p>
                <div class="bar" id="c04"></div>
                <p class="pGraphInt">8,000</p>
                <div class="bar" id="c05"></div>
                <p class="pGraphInt">10,000</p>
                <div class="bar" id="c06"></div>
                <!--<p class="pGraphInt">6,000</p>
                <div class="bar" id="c07"></div>
                <p class="pGraphInt">7,000</p>
                <div class="bar" id="c08"></div>
                <p class="pGraphInt">8,000</p>-->
                <div class="lineas-verticales">
                    <div class="linea-vertical" id="v1"></div>
                    <div class="linea-vertical" id="v2"></div>
                    <div class="linea-vertical" id="v3"></div>
                    <div class="linea-vertical" id="v4"></div>
                    <div class="linea-vertical" id="v5"></div>
                    <div class="linea-vertical" id="v6"></div>
                </div>
            </div>
                <div class="barTr" *ngFor="let consultorio of consultorios; let i = index">
                    <div class="bar" id="brs{{+i}}" [ngStyle]="{ 'width': (consultorio.percent/1.5)  + '%' }">
                        <span class="label">{{consultorio.year}}</span>
                    </div>
                    <p class="pGraph">{{consultorio.quantity | number }}</p>
                </div>
            
            </div>
        </div>
    </div>
</div> 
</div>
